module.exports = __webpack_public_path__ + "static/media/LCScriptWeb-Regular.4278eac1.eot";